import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/shared/ui';

/**
 * Stands in for the body of a report section that has no data, under the section's own
 * header, naming the section so the page does not read as blank. `flex-1` fills the layout's
 * body so the state centres on the page.
 */
export const SectionUnavailable = ({ category }: { category: string }) => {
  const { t } = useTranslation('analysis');

  return (
    <EmptyState
      className="flex-1"
      title={t('analysis.sectionUnavailable.title', { category })}
      description={t('analysis.sectionUnavailable.body', { category })}
    />
  );
};
